import type { LocationRepository } from '@/core/location'
import type { UseCase } from '@/core/shared'

export const editLocation: UseCase<LocationRepository, 'editLocation'> = repository => {
  return async (location) => {
    await repository.editLocation(location)
  }
}
